// const btnUploadInputArr = document.querySelectorAll('.btn-upload-input');
//
// btnUploadInputArr.forEach(btnUploadInput => {
//   const fileInput = btnUploadInput.querySelector('input[type="file"]');
//   const hiddenFileInput = btnUploadInput.querySelector('input[type="hidden"]');
//   if (!fileInput) return;
//
//   fileInput.addEventListener('change', () => {
//     const content = btnUploadInput.querySelector('.btn__content');
//
//     if (fileInput.files.length) {
//       content.textContent = fileInput.files[0].name;
//     }
//   });
// });

window.buttonFileUpload = function(input, fieldSelector = '#cv_field') {
  const wrapper = input.closest('.btn-upload-input');
  if (!wrapper) return;

  const content = wrapper.querySelector('.btn__content');
  const hiddenInput = wrapper.querySelector('input[type="hidden"]');

  if (!input.files.length) return;

  const file = input.files[0];
  const maxSize = 2 * 1024 * 1024;
  const allowedExtensions = ['pdf', 'doc', 'docx'];

  if (file.size > maxSize) {
    noticeError('File is too large. Maximum size is 2MB.');
    input.value = '';
    return;
  }

  const fileName = file.name;
  const fileExtension = fileName.split('.').pop().toLowerCase();

  if (!allowedExtensions.includes(fileExtension)) {
    noticeError('Invalid file format. Allowed formats are: PDF, DOC, DOCX');
    input.value = '';
    return;
  }

  if (content) {
    content.textContent = fileName;
  }

  initFile(input);
  load('page/upload/', 'field=' + fieldSelector, 'preview=#cv-preview');
};